module.exports = __webpack_public_path__ + "img/vendor-dj.a417c678.png";